import React from 'react';
import Button from '../../../main/components/Button';
import { UserSvg } from './UserSvg';

export const UserCard = ({ locales, user, loginAsUser }) => {
  const getClassText = () => {
    if (user.role === 'admin') {
      return locales.sso.adminAccount;
    }
    if (user.classrooms.length > 0) {
      return user.classrooms[0].name;
    }
    return locales.sso.notAssignedToClass;
  };
  return (
    <>
      <div className="sso-user-card">
        <div className="sso-user-card__logo-container">
          <div className="sso-user-card__text-role">
            {user.role === 'admin' && <>{locales.account.roles.admin}</>}
            {user.role === 'lecturer' && <>{locales.account.roles.lecturer}</>}
          </div>
          <UserSvg />
        </div>
        <div className="sso-user-card__text-description">
          {locales.sso.class}
        </div>
        <div className="sso-user-card__text-classroom">{getClassText()}</div>
        <div className="sso-user-card__text-description">
          {locales.sso.establishment}
        </div>
        <div>{user.establishment.name}</div>
        <div className="sign-up-form__actions sso-user-card__button-container">
          <Button
            className="bmc-button bmc-button--blue bmc-button--wide sso-user-card__button"
            onClick={(e) => {
              e.stopPropagation();
              loginAsUser(user.id);
            }}
          >
            {locales.sso.login}
          </Button>
        </div>
      </div>
    </>
  );
};
